import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { Routes } from '../../../../AppRoutes';
import { Icon } from '../../../../components';

const transferWrapper = (Component: FC<any>) => (props: any) => {
  return (
    <div className='transfer-wrapper'>
      <div className='TabLinks'>
        <NavLink to={Routes.ElectricBill.path}>
          <Icon.User />
          <p className='d-none d-md-block'>Nhập mã</p>
        </NavLink>

        <NavLink to={Routes.ElectricBillUpFile.path}>
          <Icon.KYC />
          <p className='d-none d-md-block'>Tải tệp</p>
        </NavLink>
      </div>

      <Component {...props} />
    </div>
  );
};

export default transferWrapper;
